import React, { Component } from 'react';
// import synth from './synths/basic';
// import SettingSection from './setting-section';
import _ from 'lodash';
import tone from 'tone';
import programmer from './tones';
import './styles.css';

let counter = 0;


// Tone.Draw is useful for synchronizing visuals and audio events.

class App extends Component {
  constructor() {
    super();
    this.state = this.getNewState();
  }

  // getNewState = () => {
  //   return {
  //     synthSettings: synth.get()
  //   }
  // }
  getNewState = () => {
    return {
      activeNotes: [],
      position: 0,
      center: window.outerWidth / 2,
      range: 4
    }
  }

  getPosition = () => {
    this.setState({
      activeNotes: this.state.activeNotes.reduce( (notes, n) => {
        const progress = (
          (programmer.transport.ticks - n.time) / (n.time - n.end)
        ) / 4;

        if (progress < 1.3) {
          notes.push({
            ...n,
            progress
          });
        }

        return notes;
      }, [])
    })

    window.requestAnimationFrame(this.getPosition);
  }

  componentDidMount() {
    // programmer.bus.on('note', note => {
    //   this.setState({ activeNotes: this.state.activeNotes.concat({
    //     id: counter,
    //     note: note,
    //     index: note.noteIndex,
    //     end: tone.Time(note.time).add(note.duration).toTicks(),
    //     time: tone.Time().addNow(note.time).toTicks()
    //   })})
    //   counter++;
    // });

    window.requestAnimationFrame(this.getPosition)
  }

  // onReset = e => {
  //   e.preventDefault();
  //   synth.resetSettings();

  //   this.setState(this.getNewState());
  // }

  render() {
    return (
      <div className="App">
        <button type="button" onClick={() => tone.Transport.stop()}>Stop</button>

        <button type="button" onClick={() => tone.Transport.start()}>start</button>
        <div className="notes">
          { this.state.activeNotes.map( n => (
            n.progress < 0 ? null : (
              <div key={n.id} className="note" style={{
                left: 50 - (100 * n.progress) + '%',
                top: ((n.index / programmer.notes.length) * 100) + '%'
              }}/>
            )
          ))}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js